import type { CreateChatThread200AllOfCurrentUserStatusStatus } from './createChatThread200AllOfCurrentUserStatusStatus';

export type CreateChatThread200AllOfCurrentUserStatus = {
  /** @nullable */
  acceptedAt?: string | null;
  /** @nullable */
  invitedBy?: string | null;
  /** @nullable */
  requestedAt?: string | null;
  status: CreateChatThread200AllOfCurrentUserStatusStatus;
};
